<script setup lang="ts">
import { computed, inject, watch } from "vue";
import { FormElementType, FormTextFormElement } from "~/api";
import {
  FormResponseState,
  formResponseInjectKey,
} from "../../composables/useFormResponse";
import { DefaultFormComponentProps } from "./FormComponentRenderer.vue";

const props = defineProps<DefaultFormComponentProps<FormTextFormElement>>();

const { useAnswer, substituteTemplatedText } = inject(
  formResponseInjectKey,
  // Cast the type since we know it is always provided. For more info see:
  // https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject
) as FormResponseState;
const answer = useAnswer<FormElementType.FORM_TEXT>(props.modelValue);
const elementProperties = computed(() => props.modelValue.properties);

const contentSub = computed(
  () =>
    substituteTemplatedText(
      elementProperties.value.content,
      props.modelValue.repeaterGuid,
    ) ?? undefined,
);

const handleUpdateAnswer = () => {
  answer.value = contentSub.value;
};

watch(
  () => contentSub.value,
  () => {
    if (elementProperties.value.saveAsDisplayed) {
      handleUpdateAnswer();
    }
  },
);
</script>

<template>
  <div v-if="!elementProperties.isHidden" class="FormTextComponent">
    <!-- eslint-disable-next-line vue/no-v-html  -->
    <div class="form-text-label" v-html="contentSub" />
  </div>
</template>

<!-- Not scoped to override the font-weight in `main.css` -->
<style lang="less">
.FormTextComponent {
  div.form-text-label {
    font-size: 1em;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0; // this is overridden for h1 and h3 in .formHost and .h2 in .form-designer
  }
}
</style>
